import {
  IDataResponse,
  IFile,
  IFilter,
} from '../services/api/requests/getAudioList';

const getAudioTitle = (file: IFile) => {
  if (file?.quotes.length > 0) {
    const sriIsopanisad = file.quotes[0]?.book?.scripture === 4;
    const nectarOfDevotion = file.quotes[0]?.book?.scripture === 5;
    const name = file.quotes[0]?.scripture.title;
    const hasBook = file.quotes[0]?.scripture.has_book;
    const book = (hasBook && file.quotes[0]?.book?.title) || '';
    const bookStr = `${book + (parseInt(book) ? '.' : ' ')}`;
    const chapter = `${file.quotes[0]?.chapter || ''}`;

    if (sriIsopanisad || nectarOfDevotion) {
      const verses = file.quotes.reduce((acc, item, i, allQuotes) => {
        if (allQuotes.length > 1) {
          acc = `${allQuotes[0].book.title} - ${
            allQuotes[allQuotes.length - 1].book.title
          }`;
          return acc;
        }

        acc = `${item.book.title}`;
        return acc;
      }, `${file.quotes[0]?.verse}`);

      return `${name} ${verses}`;
    }

    const verse = file.quotes.reduce((acc, item, i, allQuotes) => {
      if (allQuotes.length > 1) {
        acc = `.${allQuotes[0].verse}-${allQuotes[allQuotes.length - 1].verse}`;
        return acc;
      }

      acc = `.${item.verse}`;
      return acc;
    }, `${file.quotes[0]?.verse}`);

    return `${name} ${bookStr}${chapter}${verse}`;
  }
  return file.title;
};

export const normalizeData = (data: IDataResponse) => {
  const ignoreFilterList = ['t'];

  let normalizedData: IDataResponse = {
    count: 0,
    next: null,
    previous: null,
    results: {
      files: data.results.files,
      filters: data.results.filters,
    },
  };

  if (data) {
    const filters =
      data?.results?.filters?.filter(
        (f: IFilter) => !ignoreFilterList.includes(f.name),
      ) || [];

    normalizedData = {
      ...data,
      results: {
        files: data?.results?.files.map((file: IFile) => ({
          ...file,
          isPlaying: false,
          audioTitle: getAudioTitle(file),
        })),
        filters,
      },
    };
  }
  return normalizedData;
};
